"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var SummaryBlocks_meta_1 = require("../SummaryBlocks.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var withSelector_1 = require("../../../../shared/withSelector");

var SummaryBlock_1 = __importDefault(require("../../SummaryBlock/SummaryBlock"));

var Block = function Block(props) {
  var className = props.className,
      weight = props.weight,
      basis = props.basis,
      blockProps = __rest(props, ["className", "weight", "basis"]);

  var Section = withSelector_1.withSelector('section', props);
  var style = {
    flex: 'auto'
  };

  if (weight) {
    style.flexGrow = weight;
  }

  if (basis) {
    style.flexBasis = basis;
  }

  return react_1.default.createElement(Section, {
    className: className,
    style: style
  }, react_1.default.createElement(SummaryBlock_1.default, __assign({}, blockProps)));
};

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Block, SummaryBlocks_meta_1.SUMMARY_BLOCKS_CATEGORY_KEY, SummaryBlocks_meta_1.SUMMARY_BLOCKS_COMPONENT_KEY, ['block']);